import { render, staticRenderFns } from "./subPageSeven.vue?vue&type=template&id=c33bf306&scoped=true"
var script = {}
import style0 from "./subPageSeven.vue?vue&type=style&index=0&id=c33bf306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33bf306",
  null
  
)

export default component.exports